function isKorean(text) {
  const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

export { isKorean };
//# sourceMappingURL=isDef.mjs.map
